<ng-container id="pwa-detector"></ng-container>
